import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { SelectedDateRange } from './datePicker';
import DashboardDatePickers from "./datePicker"
import SelectDropdown, { ISelectDropdownItem } from '../../../form-control/SelectDropdown';
import { IDateRange } from '../../../../resources/interfaces';
import clsx from 'clsx';
import { DATE_RANGE_TYPES } from '../../../../resources/enums';
import { getSelectItemsFromEnum } from '../../../../utilities/miscFunctions';
interface DateRangeSelectoProps {
  options?: string[];
  onChange: (value: SelectedDateRange) => void;
  dateRangeType?: DATE_RANGE_TYPES;
  dateRange?: SelectedDateRange;
  className?: string;
}

const DATE_FORMAT = 'YYYY-MM-DD';

function getRange(rangeKey: DATE_RANGE_TYPES): SelectedDateRange {
  let from: string; let to: string;
  switch (rangeKey) {
    case DATE_RANGE_TYPES.TODAY: {
      from = moment(new Date()).format(DATE_FORMAT);
      to = moment(new Date()).format(DATE_FORMAT)
    }
      break;

    case DATE_RANGE_TYPES.YESTERDAY: {
      from = moment().subtract(1, 'day').startOf("day").format(DATE_FORMAT);
      to = moment().subtract(1, 'day').endOf("day").format(DATE_FORMAT);
    }
      break;

    case DATE_RANGE_TYPES.LAST_7_DAYS: {
      from = moment(new Date()).subtract(7, 'day').format(DATE_FORMAT);
      to = moment(new Date()).format(DATE_FORMAT)
    }
      break;

    case DATE_RANGE_TYPES.THIS_WEEK: {
      from = moment().startOf('week').format(DATE_FORMAT);
      to = moment(new Date()).format(DATE_FORMAT)
    }
      break;

    case DATE_RANGE_TYPES.THIS_MONTH: {
      from = moment().startOf('month').format(DATE_FORMAT);
      to = moment(new Date()).format(DATE_FORMAT)
    }
      break;

    case DATE_RANGE_TYPES.LAST_MONTH: {
      from = moment().subtract(1, 'month').startOf("month").format(DATE_FORMAT);
      to = moment().subtract(1, 'month').endOf("month").format(DATE_FORMAT);
    }
      break;

    case DATE_RANGE_TYPES.LAST_YEAR: {
      from = moment().startOf("year").subtract(1, 'year').format(DATE_FORMAT);
      to = moment().endOf("year").subtract(1, 'year').format(DATE_FORMAT);
    }
      break;

    case DATE_RANGE_TYPES.YEAR_TO_DATE: {
      from = moment().startOf("year").format(DATE_FORMAT);
      to = moment(new Date()).format(DATE_FORMAT)
    }
      break;

    default: {
      from = "";
      to = ""
    }
  }

  return {
    from,
    to
  }
}

const getSize = (windowWidth: number) => {
  return windowWidth <= 1024;
}

const DateRangeSelector = (props: DateRangeSelectoProps) => {
  const [selectedDateRange, setSelectedDateRange] = useState(props.dateRangeType ?? DATE_RANGE_TYPES.YEAR_TO_DATE);
  const [dateRange, setDateRange] = useState<IDateRange>(props.dateRange ?? getRange(selectedDateRange));
  const windowWidth = useRef(window.innerWidth);

  useEffect(() => {
    props.onChange(getRange(selectedDateRange));
  }, [])

  const onChange = (dateRangeKey: DATE_RANGE_TYPES) => {
    setSelectedDateRange(dateRangeKey)
    props.onChange(getRange(dateRangeKey))
  }

  const onDatePickerChange = (dateRange: SelectedDateRange) => props.onChange(dateRange);

  return (
    <div className={(getSize(windowWidth.current) && selectedDateRange === DATE_RANGE_TYPES.CUSTOM_DATE) ? 'flex-col justify-between' : 'flex justify-between'}>
      <div className={clsx(`w-full`, props.className)}>
        <SelectDropdown
          listSelectedValue={selectedDateRange}
          onChange={(value: string) => onChange(value as DATE_RANGE_TYPES)}
          wrapperClasses="pl-0 pr-0 text-sm bg-transparent w-full"
          list={getSelectItemsFromEnum(DATE_RANGE_TYPES)}
          selectInputClassName={"!bg-transparent !text-dark border-[1px] !border-gray-300 hover:dark:!border-primary-dark-border_active !focus:border-dark !outline:border-dark !focus:ring-dark rounded-[3px] pl-0 pr-8 py-0 !outline:dark:border-primary-dark-border_active !focus:dark:border-primary-dark-border_active"}
          IconClass={"!text-[#000000]"}
        />
      </div>
      {(selectedDateRange === DATE_RANGE_TYPES.CUSTOM_DATE) && <DashboardDatePickers fromDate={new Date(dateRange.from)} toDate={new Date(dateRange.to)} onSubmit={onDatePickerChange} classes='px:0' />}
    </div>
  );
}

const YEARS = [2023, 2022]
const QUARTERS = ['Q1', 'Q2', 'Q3', 'Q4']


export function PoliciesYearRangeSelector(props: any) {
  const [selectedDateRange, setSelectedDateRange] = useState("");

  const onChange = (dateRangeKey: string) => {
    setSelectedDateRange(dateRangeKey)
    props.onPoliciesYearChange(dateRangeKey)
  }

  return (
    <select
      className="pl-5 sm:pl-7 pr-18 sm:pr-11 py-1 sm:py-3 text-sm sm:text-md rounded-md float-right bg-transparent"
      value={selectedDateRange}
      onChange={(e) => onChange(e.target.value)}>
      {
        YEARS.map((y, i) => <option className='text-xs sm:text-md' key={i} value={y}>{y}</option>)
      }
    </select>
  );
}

export function PoliciesQuarterDateRangeSelector(props: any) {
  const [selectedDateRange, setSelectedDateRange] = useState("");

  const onChange = (dateRangeKey: string) => {
    setSelectedDateRange(dateRangeKey)
    props.onPoliciesQuarterChange(dateRangeKey)
  }

  return (
    <select
      className="pl-5 sm:pl-7 pr-18 sm:pr-11  py-1 sm:py-3 text-sm sm:text-md rounded-md float-right bg-transparent"
      value={selectedDateRange}
      onChange={(e) => onChange(e.target.value)}>
      {
        QUARTERS.map((y, i) => <option className='text-xs sm:text-md' key={i} value={y}>{y}</option>)
      }
    </select>
  );
}

export default DateRangeSelector;
